const localePt = {
    'Crop': 'Recortar',
    'Delete-all': 'Remover tudo',
    'Delete': 'Remover',
    'Text': 'Escrever',
    'Draw': 'Desenhar',
    'Rotate': 'Rotacionar',
    'Italic': 'Itálico',
    'Underline': 'Sublinhado',
    'Bold': 'Negrito',
    'Left': 'Esquerda',
    'Center': 'Centralizado',
    'Right': 'Direita',
    'Color': 'Cor',
    'Text size': 'Tamanho do Texto',
    'Free': 'Livre',
    'Straight': 'Reto',
    'Range': 'Tamanho da Linha',
    'Download': 'Salvar Correção',
    'Undo': 'Desfazer última ação',
    'Redo': 'Refazer última ação',
    'Reset': 'Resetar',
    'Brightness': 'Brilho',
    'Filter': 'Brilho'
  }
  
  export default localePt
  